// extracted by mini-css-extract-plugin
export default {"infoBoxParagraph":"FinanceDocs_infoBoxParagraph__p5wlg"};